import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidator {
  static creditLimit(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;

      if (value === null || value === '') return null; // let required handle empty

      const num = Number(value);

      if (isNaN(num)) return { invalidFormat: true };
      if (num < 0) return { negative: true };
      if (num > 10_000_000) return { maxExceeded: true };

      return null;
    };
  }
}
